import * as THREE from "three";
import { Logger } from "@designboticteam/core";

class MainScene extends THREE.Scene {
	protected readonly logger = new Logger("MainScene");

	public initialize() {
		this.logger.log("initialized");
	}

	public update() {}
}

export { MainScene };
